export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';
export const SHOW_ERRORS = 'show_errors';
export const HIDE_ERRORS = 'hide_errors';



// WEBPACK FOOTER //
// ./src/redux/actions/types/messageTypes.js